import * as React from 'react'
import authService from './AuthorizeService'
import { registerServices } from './../services/registerServices'
import { accentUtils } from '../services/HelperService';
import { AccentDragProvider } from '../controls/AccentButton';
import { AppSplashScreen } from '../app-framework/AppSplashScreen';

const App = React.lazy(() => import('../../App'));

function AuthenticatedApp() {

    
    
    const [isAuthenticated, setIsAuthenticated] = React.useState(false);
    const [isLoadingServices, setIsLoadingServices] = React.useState(true);



    async function initApp() {

        const instance = await authService.Initialize();

        const accounts = instance.getAllAccounts();


        const instanceIsAuthenticated = accounts && accounts.length > 0;

        instance.handleRedirectPromise().then((response) => {
            if (response !== null || instanceIsAuthenticated) {


                if (window.loadTimeoutID) {
                    clearTimeout(window.loadTimeoutID);
                }

                setIsAuthenticated(true);
                loadServices();
            }
        }).catch((error) => {
            console.error(error);
        });



        if (instanceIsAuthenticated) {
            setIsAuthenticated(true);
        } else {

            try {

                await instance.loginRedirect(authService.getLoginRequest());

            } catch (e) {
                console.error(e);
            }

        }

    }

    function loadServices() {

        setIsLoadingServices(true);

        setTimeout(() => {

            registerServices().then(done => {

                setIsLoadingServices(false);

            });

        }, 10);

    }

    React.useEffect(() => {

        initApp();

    }, []);


    if (!isAuthenticated) {
        return <AppSplashScreen status="Signing you in" />;
    }


    if (isLoadingServices) {
        return <AppSplashScreen status="Loading services" />;
    }

    return (
        <AccentDragProvider>
            <App />
        </AccentDragProvider>        
    );
}




export default AuthenticatedApp;